export default __webpack_public_path__ + "static/media/color.e7b3d9d3.svg";